import { MainType } from './main-type';

export const sectionList = [
    { id: MainType.ToDo, desc: 'TO-DO' },
    { id: MainType.Other, desc: 'OTHER' },
    { id: MainType.Compliance, desc: 'COMPLIANCE' }
];